import { render, staticRenderFns } from "./incidencias.vue?vue&type=template&id=37513e30&"
import script from "./incidencias.vue?vue&type=script&lang=js&"
export * from "./incidencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports